import { createReducer, on } from '@ngrx/store';
import { ReportTypes } from '@mode/shared/contract-common';
import * as ReportDbtMetadata from './report-dbt-metadata.actions';

export const reportDbtMetadataFeatureKey = 'reportDbtMetadata';

export interface ReportDbtMetadataFeatureState {
  dbtMetaData: ReportTypes.ReportDbtMetaData | null;
  isLoading: boolean;
  isComplete: boolean;
  error: Error | null;
}

export const initialReportDbtMetadataFeatureState: ReportDbtMetadataFeatureState = {
  isLoading: false,
  dbtMetaData: null,
  isComplete: false,
  error: null,
};

export const reducer = createReducer(
  initialReportDbtMetadataFeatureState,

  on(ReportDbtMetadata.loadReportDbtMetadata, (state) => ({
    ...state,
    isLoading: true,
    isComplete: false,
    error: null,
  })),
  on(ReportDbtMetadata.loadReportDbtMetadataSuccess, (state, action) => {
    return { ...state, dbtMetaData: action.dbtMetaData, isLoading: false, error: null, isComplete: true };
  }),
  on(ReportDbtMetadata.loadReportDbtMetadataFailure, (state, action) => {
    return { ...state, error: action.error, isLoading: false, isComplete: true, dbtMetaData: null };
  })
);
